import React from 'react';
import { arrayOf, node, string } from 'prop-types';
import ActionIcon from 'components/ActionIcon';
import PinterestWidgetLib from 'components/PinterestWidgetLib';
import styles from './styles';

const SOCIAL_WIN_OPS = [
  'width=632',
  'height=253',
  'status=0',
  'toolbar=0',
  'menubar=0',
  'location=1',
  'scrollbars=1'
].join(',');

function handleFacebookClick(e) {
  e.preventDefault();
  window.open(e.currentTarget.getAttribute('href'), 'facebook', SOCIAL_WIN_OPS);
}

function handlePinterestClick(e, { postImage, postUrl, postTitle }) {
  e.preventDefault();
  // TODO: fallback URL if PinUtils is not defined
  if (window.PinUtils) {
    if (postImage) {
      window.PinUtils.pinOne({
        url: postUrl,
        media: postImage,
        description: postTitle
      });
    } else {
      window.PinUtils.pinAny();
    }
  }
}

export function SitePageActions(props) {
  const {
    placement,
    postUrl,
    postTitle,
    postImage,
    disable,
    printRecipeButton
  } = props;

  return (
    <div
      className={`SitePostActions__actions SitePostActions__actions--${placement}`}
    >
      {/* FACEBOOK */}
      {!disable.includes('facebook') && (
        <div className="SitePostActions__action SitePostActions__action--facebook">
          <ActionIcon
            target="_blank"
            type="facebook"
            isBranded
            shareProps={{ u: postUrl }}
            onClick={handleFacebookClick}
            linkAttrs={{
              'data-gtm-placement': placement
            }}
            variant="siteBranded"
          />
        </div>
      )}
      {/* PINTEREST */}
      {!disable.includes('pinterest') && (
        <div className="SitePostActions__action SitePostActions__action--pinterest">
          <ActionIcon
            target="_blank"
            url="#pinit"
            type="pinterest"
            isBranded
            linkAttrs={{
              'data-gtm-placement': placement,
              ...(postImage
                ? {
                    'data-pin-do': 'buttonPin',
                    'data-pin-custom': 'true',
                    'data-pin-media': postImage
                  }
                : {
                    'data-pin-do': 'buttonBookmark',
                    'data-pin-custom': 'true'
                  })
            }}
            onClick={e =>
              handlePinterestClick(e, { postImage, postUrl, postTitle })
            }
            variant="siteBranded"
          />
          <PinterestWidgetLib />
        </div>
      )}
      {/* PRINT RECIPE */}
      {printRecipeButton !== null && printRecipeButton}
      {/* EMAIL */}
      {!disable.includes('email') && (
        <div className="SitePostActions__action SitePostActions__action--email">
          <ActionIcon
            target="_blank"
            type="email"
            isBranded
            inheritedClass="postupshare"
            shareProps={{ body: postUrl, subject: postTitle }}
            linkAttrs={{
              'data-gtm-placement': placement
            }}
            variant="siteBranded"
          />
        </div>
      )}
      <style jsx>{styles}</style>
    </div>
  );
}

SitePageActions.defaultProps = {
  postImage: undefined,
  printRecipeButton: null,
  disable: []
};

SitePageActions.propTypes = {
  placement: string.isRequired,
  printRecipeButton: node,
  postUrl: string.isRequired,
  postTitle: string.isRequired,
  postImage: string,
  disable: arrayOf(string)
};

export default SitePageActions;
